import _ from "lodash";
import { apiErrorMessage } from "./apiError";

/**
 * saga 的統一錯誤出口。
 *
 * 401 是憑證過期，直接踢回登入頁；其餘一律把「人看得懂的原因」跳出來。
 * 訊息一律交給 apiErrorMessage 產生——尤其 403（權限不足）後端是空 body，
 * 這裡若只讀 res_msg 就會變成「系統發生錯誤！」，使用者會以為系統掛了。
 */
export default function exception(error) {
  const resCode = _.get(error, "response.status", 400);

  switch (resCode) {
    case 401:
      window.location.href = "/Auth/Login";
      break;
    /*
     * 403 用不阻斷的 toast，不要用 window.alert。
     *
     * 頁面載入時常常一次打好幾支 API，只要其中一支需要的權限這個角色沒有，
     * 原本就會彈出一個必須點掉的原生對話框 —— 一次載入撞兩支就要點兩次。
     * 使用者的感受是「系統壞了」，實際上只是某個區塊他沒被授權。
     * 改成 toast 之後，最壞情況也只是一則提示加上該區塊沒資料。
     *
     * toast 由 Layout 掛載時掛上 window.__EL_TOAST__；登入頁那些在 Layout 之外的
     * 畫面拿不到，就退回原本的 alert，不會有訊息消失的情況。
     */
    default: {
      const msg = apiErrorMessage(error);
      if (typeof window.__EL_TOAST__ === "function") window.__EL_TOAST__(msg);
      else window.alert(msg);
      break;
    }
  }
}
